import type { TOC } from '@ember/component/template-only';

const ErrorRouteTemplate: TOC<object> = <template>
	<div id="error">
		ERROR
	</div>
</template>;

export default ErrorRouteTemplate;
